export function setFormSections(state, formSections) {
  state.formSections = formSections;
}
